import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminLayoutStateService {
  readonly menuCollapsed$ = new BehaviorSubject<boolean>(false);
  readonly headerHidden$ = new BehaviorSubject<boolean>(false);
}
